import { Wrench, Settings, ArrowRight } from 'lucide-react'
import { business } from '../../config/business'
import SectionWrapper from '../ui/SectionWrapper'
import Card from '../ui/Card'

const ICONS = {
  installation: Settings,
  repair: Wrench,
}

export default function Services() {
  return (
    <SectionWrapper id="services" bg="alt">
      <div className="max-w-6xl mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-14">
          <span className="fade-in-up inline-block text-accent-500 font-semibold text-sm uppercase tracking-widest mb-3">
            What We Do
          </span>
          <h2 className="fade-in-up font-heading font-bold text-navy-900 text-4xl md:text-5xl">
            Our Services
          </h2>
        </div>

        {/* Service cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {business.services.map((service) => {
            const Icon = ICONS[service.id] ?? Wrench
            return (
              <Card key={service.id} className="fade-in-up p-8 md:p-10">
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-accent-50 flex items-center justify-center mb-6">
                  <Icon size={26} className="text-accent-500" />
                </div>

                {/* Title + subtitle */}
                <h3 className="font-heading font-bold text-navy-800 text-2xl mb-1">
                  {service.title}
                </h3>
                <p className="text-accent-500 font-semibold text-sm mb-4">{service.subtitle}</p>

                {/* Description */}
                <p className="text-ink-600 leading-relaxed mb-6">{service.description}</p>

                {/* Feature tags */}
                <div className="flex flex-wrap gap-2 mb-8">
                  {service.tags.map((tag) => (
                    <span
                      key={tag}
                      className="bg-navy-50 text-navy-800 text-xs font-semibold px-3 py-1.5 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* CTA link */}
                <a
                  href="#contact"
                  className="inline-flex items-center gap-1.5 text-accent-500 hover:text-accent-600 font-semibold text-sm transition-colors duration-200"
                >
                  Request a Quote
                  <ArrowRight size={15} />
                </a>
              </Card>
            )
          })}
        </div>
      </div>
    </SectionWrapper>
  )
}
